import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api";

/** Status of the AI provider keys — never includes the key itself. */
export interface AiSettingsStatus {
  /** The encrypted store can accept writes (CINCH_OPS_SETTINGS_SECRET set). */
  secret_store_ready: boolean;
  claude_configured: boolean;
  /** Where the active key comes from: in-app setting, env fallback, or none. */
  claude_key_source: "app" | "env" | null;
  claude_default_model: string | null;
  openai_configured: boolean;
  openai_key_source: "app" | "env" | null;
  openai_default_model: string | null;
}

/** A partial update: a field left undefined is unchanged; "" clears it. */
export interface AiSettingsUpdate {
  anthropic_api_key?: string;
  claude_default_model?: string;
  openai_api_key?: string;
  openai_default_model?: string;
}

const KEY = ["settings", "ai"] as const;

export function useAiSettings(enabled = true) {
  return useQuery({
    queryKey: KEY,
    queryFn: () => apiFetch<AiSettingsStatus>("/settings/ai"),
    enabled,
  });
}

export function useUpdateAiSettings() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: AiSettingsUpdate) =>
      apiFetch<AiSettingsStatus>("/settings/ai", { method: "PUT", body: input }),
    onSuccess: (data) => qc.setQueryData(KEY, data),
  });
}
